import _ from 'lodash'

/**
 * Returns the source of how the user got created/added
 * @param {*} user
 * @returns {'SCIM' | 'Procyon'}
 */
export const getUserSource = (user) => (user.Status.Source === 'SCIM' ? 'SCIM' : 'Privilege')

/**
 * Returns true, if the user is active else false.
 * @param {*} user
 * @returns {'Active'|'InActive'}
 */
export const getUserStatus = (user) => (!!user.Spec.Active ? 'Active' : 'InActive')

/**
 * Check if a user is admin or not
 * @param {*} user The user to check for
 * @returns If the user is admin i.e. belongs to admin group then returns `true`, else returns `false`
 */
export const isAdminUser = (user) => {
  if (user?.Spec?.UserRoles?.includes(USER_ROLES_MAP.ProcyonAdminRole)) return true
  return false
}

/**
 * Get the refs of the groups in which the user is.
 * @param {*} user
 * @returns Array of ref objects of all groups in which the `user` is member of.
 */
export const getUserGroupsRefs = (user) => user.Spec.Groups?.ObjectRef || []

/**
 * Get all the devices owned by the user
 * @param {*} devices All the devices
 * @param {*} user The user to filter the devices on
 * @returns
 */
export const getUserOwnedDevices = (devices = [], user) => {
  return _.filter(devices, { UserName: user?.ObjectMeta.Name })
}

/**
 * Get the display name for user.
 * @param {*} user
 * @param {boolean} useMeta If true, return ObjectMeta.Name when no naming fields are present
 * @returns {string} Display name of the user.
 */
export const getUserDisplayName = (user, useMeta = true) => {
  if (!user) return ''
  const { FirstName, LastName, FullName } = user.Spec
  if (FullName) return FullName
  else if (FirstName && LastName) return `${FirstName.trim()} ${LastName.trim()}`
  else if (useMeta) return user.ObjectMeta.Name
  return ''
}

export const getGroupDisplayName = (group) => {
  if (!group) return ''
  const { Attributes } = group.Spec
  if (Attributes?.Map?.name) return Attributes.Map.name
  return group.ObjectMeta.Name
}

/**
 * Get all the groups in which the user is present.
 * @param {object} user
 * @param {any[]} groups
 * @returns Groups in which the user is in
 */
export const getUserGroups = (user, groups = []) => {
  const userID = user.ObjectMeta.ID
  return groups.filter((g) => _.find(g.Spec.Users?.ObjectRef || [], { RefID: userID }))
}

export const getUserServerName = (user) => user.Spec.ServerUserName

/**
 * Get user roles array: ["procyon:admin"]
 * @param {*} user The user object
 * @returns {string[]}
 */
export const getUserRoles = (user) => {
  //remove debug
  const rolesStr = user.Spec.UserRoles || ''
  const roles = rolesStr.split(',')
  return roles.filter((e) => e)
}

export const USER_ROLES_MAP = {
  ProcyonAdminRole: 'procyon:admin',
  ProcyonUserRole: 'procyon:user',
  ProcyonAuditRole: 'procyon:audit',
  ProcyonAutoApproveRole: 'procyon:autoapprove',
  ProcyonAgentlessRole: 'procyon:agentless'
}

export const USER_ROLES_ARRAY = Object.values(USER_ROLES_MAP)
